const defaultRender = (value) => (value ? value : "--");

const statusFilter = [
  {text: "Pending", value: "pending"},
  {text: "Approved", value: "approved"},
]

const columns = [
  {
    title: "File Name",
    dataIndex: "file",
    render: defaultRender,
  },
  {
    title: 'File No.',
    dataIndex: 'file_number',
    render: defaultRender,
  },
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: defaultRender,
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
    filters: statusFilter,
    onFilter: (value, record) => {
      return record?.statusValue === value;
    }
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

export default columns;
